import React from 'react';
import KPICard from '../../../components/KPICard';
import { mapGeoKpiToCardProps } from '../utils/geoPresentation';
import { getPromptPulseMetricDefinition } from '../utils/promptPulseMetricDefinitions';

const KPI_PLACEHOLDERS = [
  { key: 'our_company_mentions', title: 'OUR COMPANY MENTIONS' },
  { key: 'our_average_position', title: 'OUR AVERAGE POSITION' },
  { key: 'mention_share', title: 'MENTION SHARE' },
  { key: 'share_of_voice', title: 'SHARE OF VOICE' },
  { key: 'active_prompts', title: 'ACTIVE PROMPTS' },
];

export default function GeoInsightsKpiColumn({ kpiCards = [], loading = false }) {
  if (loading) {
    return (
      <div className="kpi-banner-grid geo-insights-kpi-grid">
        {KPI_PLACEHOLDERS.map((kpi, index) => (
          <KPICard
            key={kpi.title}
            title={kpi.title}
            titleTooltip={getPromptPulseMetricDefinition(kpi.key)}
            value="—"
            staggerIndex={index}
            animate={false}
          />
        ))}
      </div>
    );
  }

  if (!kpiCards.length) {
    return (
      <div className="insights-chart-area insights-chart-area--md geo-insights-kpi-grid--empty">
        No data present
      </div>
    );
  }

  return (
    <div className="kpi-banner-grid geo-insights-kpi-grid">
      {kpiCards.map((kpi, index) => (
        <KPICard
          key={kpi.title}
          {...mapGeoKpiToCardProps(kpi)}
          staggerIndex={index}
        />
      ))}
    </div>
  );
}
